import emojiRegex from "emoji-regex";

import { pinyin } from "pinyin-pro";

const enCodeEmoji = (str) => {
  const regex = emojiRegex();
  return str.replace(regex, (p) => `emoji(${p.codePointAt(0)})`);
};

const deCodeEmoji = (str) => {
  const emojiDecodeRegex = /emoji\(\d+\)/g;
  return str.replace(emojiDecodeRegex, (p) => {
    const filterP = p.replace(/[^\d]/g, "");
    return String.fromCodePoint(filterP);
  });
};

// 屏蔽词检测函数
const pinyinDict = [
  "yi",
  "er",
  "san",
  "si",
  "wu",
  "liu",
  "qi",
  "ba",
  "jiu",
  "ling",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "0",
];
// const checkmaskWords = (str) => {
//   // 去除 HTML 标签和空格
//   str = str.replace(/<[^>]+>/g, ""); // 去掉所有的 HTML 标记
//   str = str.replace(/ /g, ""); // 去除空格
//   //   console.log("去除空格后的内容:", str);

//   // 检测拼音
//   const pinyinList = pinyin(str, { toneType: "none", type: "array" });
//   //   console.log("拼音检测后的内容:", pinyinList.join(""));
//   return isSensitive(pinyinList);
// };

// // 连续检测五个拼音库里的内容
// const isSensitive = (pinyinList) => {
//   for (let i = 0; i < pinyinList.length - 4; i++) {
//     const subList = pinyinList.slice(i, i + 5);
//     // console.log("连续检测五个拼音库里的内容:", subList);
//     if (subList.every((pinyin) => pinyinDict.includes(pinyin))) {
//       return true;
//     }
//   }
//   return false;
// };

// -------正则去除屏蔽词
const checkmaskWords = (str) => {
  // 去除 HTML 标签和空格
  str = str.replace(/<[^>]+>/g, "").replace(/ /g, ""); // 去掉所有的 HTML 标记和空格

  // 构建正则表达式
  const pinyinRegex = new RegExp(pinyinDict.join("|"), "g");

  // 检测拼音
  const matches = str.match(pinyinRegex);
  if (!matches) return false;

  // 连续检测五个拼音库里的内容
  for (let i = 0; i <= matches.length - 5; i++) {
    const subList = matches.slice(i, i + 5);
    if (subList.every((pinyin) => pinyinDict.includes(pinyin))) {
      return true;
    }
  }
  return false;
};

const debounce = (fn, delay) => {
  let timer = null;
  return function(...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
};

// 将方法暴露出去
export { enCodeEmoji, deCodeEmoji, checkmaskWords, debounce };
